export default "/images/physical_activity_staff_practices_sm.jpg?3ef8ae47af04b401a9a52a41379357c5";